import { Component, AfterViewInit, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ConfigService } from './config.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { FaviconService } from './_services/favicon.service';
import { StoreService } from './_services/store.service';
import { StorefrontThemeService } from './_services/storefront-theme.service';
import { OrderService } from './order.service';
import { Store } from './models/store';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

interface ApiResponse {
  id: number;
  store: number;
  favicon_file: string;
}


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit{
  endpoint = environment.orderApiBackend;
  token = environment.accessToken;
  loadingBarColor = localStorage.getItem('_brand_color') || '#29d';




  title:string;
  apiUrl: any;
  accessToken: any;
  idStore: any;
  constructor(private configService:ConfigService, private router: Router,
    private route: ActivatedRoute, private http: HttpClient, private faviconService: FaviconService,
    private storeService: StoreService, private storefrontThemeService: StorefrontThemeService,
    private orderService: OrderService,
    private cdr: ChangeDetectorRef){
    // Restore cached theme instantly — prevents flash of unthemed content on reload
    this.storefrontThemeService.restoreFromCache();
    this.idStore = localStorage.getItem("currentStore");
    this.apiUrl = `${this.endpoint}/backend/v2/stores/favicon/${this.idStore}`;
    this.accessToken = `Token ${this.token}`;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }
    });
  }

  ngOnInit(){
    this.configService.title.subscribe((val:string) => {
      this.title = val;
      this.fetchFavicon();
      this.cdr.markForCheck();
    })
    this.storeService.current.subscribe(store => {
      this.storefrontThemeService.apply(store);
      const flags: any = store?.feature_flag || {};
      if (store?.storefront_brand_color && flags['storefront_theming_enabled']) {
        this.loadingBarColor = store.storefront_brand_color;
        localStorage.setItem('_brand_color', store.storefront_brand_color);
        this.cdr.markForCheck();
      } else {
        this.loadingBarColor = '#29d';
        localStorage.removeItem('_brand_color');
      }
    })

    // On direct page reload, load the stored store and apply theme
    if (this.idStore) {
      this.orderService.getStoreInfo(this.idStore).subscribe(store => {
        const s = Object.assign(new Store(), store);
        this.storeService.changeStore(s);
      });
    }
  }

  fetchFavicon(): void {
    const headers = new HttpHeaders().set('Authorization', `${this.accessToken}`);
    
    this.http.get<ApiResponse>(this.apiUrl, { headers })
      .subscribe(response => {
        const iconUrl = response.favicon_file;
        this.faviconService.setFavicon(iconUrl);
        this.cdr.markForCheck();
      });
  }
  goBack() {
    window.history.back()
  }

}
